import { Alert, Container, Stack, Typography, Button } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material';
import { AiApi, languageKey } from '@api';
import { useContext, useEffect } from 'react';
import { ActivityContext } from '@/contexts/ActivityContext';
import { useStarValuePersona } from '@/personas/useStarValuePersona';
import { useAiUsable } from '@/utils/ai';

const TaskCreated = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const lang = i18n.language.split('-')[0];
  const { palette } = useTheme();
  const { activity } = useContext(ActivityContext);
  const { needsApproval } = useStarValuePersona();
  const aiUsable = useAiUsable();
  // Brukarens valda värde är ett förslag som ger noll stjärnor tills handledaren
  // fastställt det. Kravet gäller hela spannet 1-5, så inget värde undantas.
  const awaitingApproval = needsApproval;
  const isLanguageKey = (lang: any): lang is languageKey => {
    return ['sv', 'en', 'de', 'fr', 'es', 'it', 'pl', 'nb', 'da', 'fi'].includes(lang);
  };

  useEffect(() => {
    // Förladdning av nästa omgångs förslag. Utan användbar AI hoppas den över helt:
    // anropet svarade 500 och blev en kraschskärm ovanpå en aktivitet som faktiskt hade
    // skapats. (AiApi sväljer numera felet också — det här är det andra av två lager.)
    if (!aiUsable) return;
    const aiApi = new AiApi();
    aiApi.clearSuggestionCache();
    aiApi.activitySuggestions(isLanguageKey(lang) ? lang : 'sv');
  }, [aiUsable]);

  return (
    <Container
      sx={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%,-50%)' }}
    >
      <Stack direction={'column'} justifyContent={'center'} alignItems={'center'} spacing={2}>
        <Typography variant="h5" fontWeight={'bold'}>
          {t('Activity Created')}
        </Typography>
        <CheckCircleOutlineIcon sx={{ color: palette.success.main, fontSize: '4em' }} />
        {awaitingApproval && (
          <Alert severity="info" sx={{ width: '100%' }}>
            {t('starValue.createdPending')}
          </Alert>
        )}
        <Button onClick={() => navigate('/')} variant={'contained'} sx={{ width: '100%', p: 2 }}>
          {t('Done')}
        </Button>
      </Stack>
    </Container>
  );
};

export default TaskCreated;
